import {createStyles, makeStyles, Theme} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            padding: '16px',
            [theme.breakpoints.up('sm')]: {
                padding: '25px 0',
            }
        },
        diseaseCodesFieldset: {
            margin: 0,
            minWidth: 0,
            padding: '4px 16px 8px',
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: theme.shape.borderRadius,
        },
        diseaseCodesLegend: {
            padding: '0 6px',
            color: theme.palette.text.secondary,
            fontSize: theme.typography.pxToRem(12),
        },
        button:{
            width:'100%',
            [theme.breakpoints.up('sm')]: {
                    width:'auto'
            }
    
        },
       
    }),
);

export default useStyles;
